import { useState, useEffect, useCallback } from 'react'
import axios from 'axios'
import { baseURL } from '../config'
import { useDispatch, useSelector } from 'react-redux'
import { setRefreshPage } from '../../redux/globalSlice'

const useTeacher = ({ schoolID, page = 1, limit = 10 ,search='',grade_id,section_id}) => {
  const dispatch = useDispatch()
  const shouldRefresh = useSelector((state) => state.global.refreshPage)

  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [count, setCount] = useState(0)

  // Main fetch function — memoized with useCallback
  const fetchTeachers = useCallback(async () => {
    if (!schoolID) {
      setError(new Error('schoolID is required'))
      setLoading(false)
      return
    }

    setLoading(true)
    setError(null)

    const url = `${baseURL}/dashboard-teacher-fsm/v1/teacher?school_id=${schoolID}&page=${page}&limit=${limit}&grade_id=${grade_id}&section_id=${section_id}&keyword=${search}`

    try {
      const response = await axios.get(url)
      setData(response.data?.data || [])
      setCount(response.data?.count || 0)
    } catch (err) {
      console.error('Failed to fetch teachers:', err)
      setError(err.response?.data?.message || err.message || 'Failed to load teachers')
      setData(null)
      setCount(0)
    } finally {
      setLoading(false)
      // Reset the global refresh flag after fetch completes
      dispatch(setRefreshPage(false))
    }
  }, [schoolID, page, limit, dispatch,search,grade_id,section_id])

  // Initial fetch + refetch when dependencies change
  useEffect(() => {
    fetchTeachers()
  }, [fetchTeachers])

  // Watch the global refresh flag and trigger refetch when it becomes true
  useEffect(() => {
    if (shouldRefresh) {
      fetchTeachers()
    }
  }, [shouldRefresh, fetchTeachers])

  // Expose a manual refetch function that components can call
  const refetch = useCallback(() => {
    fetchTeachers()
  }, [fetchTeachers])

  return {
    data,
    loading,
    error,
    count,
    refetch,           // ← you can call this manually from any component
    totalCount: count, // alias if you prefer
  }
}

export default useTeacher